import { useEffect } from 'react';

/**
 * The product name that leads every tab title. Kept here so it is stated once — the previous
 * per-page `document.title = '…'` effects had drifted into three different formats
 * ("Timesheet | UT", "Administration | UT Time Tracking", and index.html's
 * "UT Austin Time Tracking"), and two routes set no title at all, so they silently inherited
 * whichever page the user came from.
 */
const APP_NAME = 'Timesheets';

/**
 * Sets the tab title to `Timesheets | <page>` for the lifetime of the calling route.
 *
 * Pass the page's own name only — the product prefix is added here. Use the same wording the
 * user sees in the header nav so the tab, the bookmark, and the nav agree.
 *
 * The title is deliberately NOT restored on unmount: every route sets its own, so a cleanup
 * would just introduce a flash of the previous title during the transition.
 */
export function usePageTitle(page: string): void {
  useEffect(() => {
    document.title = `${APP_NAME} | ${page}`;
  }, [page]);
}
